export default {
  pageNotFound: 'Page not found...',
  youRedirected: 'And you will be redirected to the start page',
  second: 'second',
  seconds: 'seconds',
  redirect: 'Redirect to the start page...',
};
